import script from "./user-data-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-data-dialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__